import { createFileRoute } from "@tanstack/react-router";
import { CouponForm } from "@/components/admin/coupon-form";

export const Route = createFileRoute("/admin/cupons/novo")({
  component: NovoCupomPage,
});

function NovoCupomPage() {
  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-eg-dark mb-6">Novo Cupom</h1>
      <CouponForm />
    </div>
  );
}
